// ── Display-name cache ───────────────────────────────────────────────────────
// The Home greeting rendered an email-derived guess for the 0.5–4s the
// get_my_profile RPC takes on boot — for craig219@… the letters-only regex
// produced "Craig", which read as a wrong-name flash (Jason, 2026-08-22).
// Same fix class as coachmarks/seenVersion (2026-08-17): mirror the
// profile-derived value into device storage on every successful profile load,
// so every boot after the first renders the real name in frame 1. The cache is
// keyed per-uid so a different account in this tab never sees the previous
// user's name. Cleared on SIGNED_OUT in useAuth.jsx.
import { safeStorage } from './safeStorage'

const KEY = 'nextep_display_name'

export function syncNameFromProfile(profile) {
  try {
    if (profile?.id && (profile.display_name || profile.username)) {
      safeStorage.set(KEY, JSON.stringify({ uid: profile.id, display_name: profile.display_name || null, username: profile.username || null }))
    }
  } catch { /* non-fatal */ }
}

export function getCachedName(uid) {
  try {
    const raw = safeStorage.get(KEY)
    if (!raw) return null
    const v = JSON.parse(raw)
    return v && v.uid === uid ? v : null
  } catch { return null }
}

export function clearCachedName() {
  try { safeStorage.remove(KEY) } catch { /* non-fatal */ }
}
